import React from 'react';

import { Icons } from '@shared/components/ui';

const AmbientSection: React.FC = () => {
  return (
    <section className="px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="bg-card border-border rounded-xl border p-8 sm:p-12">
          <div className="mx-auto max-w-3xl text-center">
            <div className="bg-muted text-muted-foreground mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full">
              <Icons.Robot size="lg" />
            </div>
            {/* Heading must cover both halves of the body: that it runs
                unprompted, AND that it starts with no authority. "Works While
                You Sleep" only covered the timing half. */}
            <h2 className="text-foreground text-3xl font-light sm:text-4xl">
              Always Running, <strong className="font-semibold">Never Presuming</strong>
            </h2>
            <p className="text-muted-foreground mt-6 text-lg leading-relaxed">
              None of that waits for you to ask. Five agents — finances, calendar, email, wellness,
              and the dates that matter to you — run whether you have opened Conway today or not.
              And they start with no authority at all: every one begins read-only, and only earns
              the right to act as you decide it has earned it.
            </p>
            <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
              <div className="bg-muted rounded-sm p-4">
                <div className="text-foreground mb-1 text-sm font-medium">Observe</div>
                <p className="text-muted-foreground text-sm">
                  Watches patterns across your life quietly in the background
                </p>
              </div>
              <div className="bg-muted rounded-sm p-4">
                <div className="text-foreground mb-1 text-sm font-medium">Suggest</div>
                <p className="text-muted-foreground text-sm">
                  Surfaces insights and recommendations when something stands out
                </p>
              </div>
              <div className="bg-muted rounded-sm p-4">
                <div className="text-foreground mb-1 text-sm font-medium">Act</div>
                <p className="text-muted-foreground text-sm">
                  Takes action on your behalf as trust grows over time
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AmbientSection;
